import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportsApi, type ReportParams, type TopClientRow } from '@/services/reports/reportsApi';

export function useTopClientsByRevenue(params: ReportParams) {
  const queryKey = useMemo(() => [
    'report',
    'top-clients-by-revenue',
    params.startDate || null,
    params.endDate || null,
    params.companyId || null,
    params.limit ?? 10,
  ], [params.startDate, params.endDate, params.companyId, params.limit]);

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      const res = await reportsApi.getTopClientsByRevenue(params);
      return res.rows;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return query as typeof query & { data: TopClientRow[] | undefined };
}
